import axios from 'axios'
import { getAPIService } from '../../../getServerHost'
import { Id } from '../../../hip/types'

export const deleteRadio = async (payload: { id: Id }) => {
  const { id } = payload
  const response = await axios.delete(`${getAPIService}/radios/${id}`)
  return response.data
}
